import { render } from "./IndexStatistique.vue?vue&type=template&id=0b917d40&scoped=true"
import script from "./IndexStatistique.vue?vue&type=script&lang=js"
export * from "./IndexStatistique.vue?vue&type=script&lang=js"

import "./IndexStatistique.vue?vue&type=style&index=0&id=0b917d40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b917d40"]])

export default __exports__